export default {
    Header: {
        Search: "Search",
        Home: "HomePage",
        Album: "Album",
        About: "About",
        Link: "FriendLink",
        TimeList: "TimeList",
        Mark: {
            Mail: "Click, and send a mail to me",
            GitHub: "Click, and enter my GitHub",
            QQ: "Add mine QQ",
            WeChat: "Add mine WeChat"
        }
    },
    Slider: {
        Language: {
            Content: "中文",
            Title: "切换语言到中文"
        }
    },
    Notice: {
        Language: "Switch language is succeed!"
    },
    Music: {
        Title: "Music",
        Album: "This album image",
        LastMusic: "Last music",
        PlayMusic: "Play/ Pause music",
        NextMusic: "Next music",
        MusicList: "Open/ Close this music list",
        SwitchMusic: "Switch this music"
    },
    Other: {
        Maintain: "Maintaining！"
    },
    About: {
        Title: "About",
        Update: "Last Updated: ",
        News: {
            Title: "News",
            Content: [
                {
                    Title: "A paper have been accepted by <b style='color: indianred'>IEEE Transaction on Network and Service Management</b>!",
                    Date: "2023.12.23"
                },
                {
                    Title: "A paper have been accepted by <b style='color: indianred'>IEEE Transaction on Intelligent Transportation Systems</b>!",
                    Date: "2022.11.07"
                },
            ],
        },
        Blog: {
            Title: "Blog",
            Content:
            // "<p>The small station is built using the Vue.js framework. In order to improve its front-end capabilities, it does not directly use UI libraries such as ElementUI, but develops it by itself.</p>" +
            // "<p>The interface is constantly iteratively updated, and it is currently the fourth major version (Vue.js). Please move to the specific process <router-link to='/TimeList' style='color: limegreen;border-bottom: 2px solid limegreen'>TimeList</router-link>. The 4th version is currently being improved, and finally Vue is used to implement data-binding multi-components to further improve the experience, so stay tuned.</p>" +
            // "<p>Disclaimer: All articles (codes) are original. Xiaozhan is under the \"(CC BY 4.0)\" Creative Commons license.</p>" +
            // "<p style='text-indent: 2em;'>1) Competitions: LanQiao Cup, Service Creation Competition, C4-Web Technology Challenge</p>" +
            // "<p style='text-indent: 2em;'>2) Experience: thesis, conference</p>" +
            // "<p style='text-indent: 2em;'>3) Postgraduate: Master, PhD</p>" +
            // "<p style='text-indent: 2em;'>4) Say & Share: Projects</p>"+
                "<p>My current research interests include blockchain and intelligent transportation systems.</p>"
        },
        Introduction: {
            Title: "Introduction",
            Name: "Jishu Wang",
            Undergraduate: "<p><b>2015.09 - 2019.07</b>, Kunming University</b>, The college of Information Engineering, Computer Science and Technology, B.E.</p>",
            Graduate: "<p><b>2019.09 - 2022.07</b>, Yunnan University</b>, The School of Software Engineering, Software Engineering，M.E.<sup style='color: red;font-weight: bolder'> (Supervisor: Prof. Tong Li)</sup></p>",
            GraduateSupervisor: "",
            PhD: "<p><b>2022.09 - </b>, Yunnan University</b>, The School of Information, Computer Science and Technology，Ph.D<sup style='color: red;font-weight: bolder'> (Supervisor: Prof. Xuan Zhang)</sup></p>",
            PhDSupervisor: ""
        },
        Publications: {
            Title: "Publications",
            TotalCites: "Total Cites",
            GoogleScholar: "Google Scholar",
            DBLP: "DBLP",
            ResearchGate: "ResearchGate",
            FirstAuthor: "First Author",
            Trans: "IEEE Transactions (Authored)",
            CoAuthor: "Co-Author",
            HighestIF: "Highest IF (Authored)",
            HighestCite: "Highest Cite (Authored)",
            Tips:"Note: The publication of the paper is <a href=' https://jcr.clarivate.com/jcr/home ' target='_ Blank' style='color: #34cd34; Font weight: bold '><b style='color: #ff8d02;'>JCR Partition</b>, Impact Factor</a>, and<a href=' https://www.ccf.org.cn/Academic_Evaluation/By_category/' target='_ Blank' style='color: #41e0d0;'> CCF Classification </a> is based on the latest data at the earliest publication time (Early Access).",
            CAS1: "CAS Q1",
            CAS2: "CAS Q2",
            CAS3: "CAS Q3",
            CAS4: "CAS Q4",
            TopJournal: "TOP Journal",
            IF: "IF",
            Reviewing: "Reviewing",
            Accepted: "Accepted",
            Article: "Article",
            First: [
                {
                    Year: 2023,
                    Date: "2023.12.28",
                    Title: "LearningChain: A Highly Scalable and Applicable Learning-Based Blockchain Performance Optimization Framework",
                    Authors: "<b style='color: red'>Jishu Wang</b>, Yaowei Wang, Xuan Zhang<sup>*</sup>, Zhi Jin, Chao Zhu, Linyu Li, Rui Zhu, Shenglong Lv",
                    Journal: "IEEE Transactions on Network and Service Management (TNSM)",
                    Level: "SCI",
                    Area: "",
                    JCR: "JCR Q2",
                    CCF: "CCF-C",
                    IF: "IF: 5.3",
                    TOP: "",
                    Cite: 2,
                    State: "Article",
                    Link: "https://ieeexplore.ieee.org/document/10375789"
                },
                {
                    Year: 2022,
                    Date: "2022.11.23",
                    Title: "BPR: Blockchain-Enabled Efficient and Secure Parking Reservation Framework with Block Size Dynamic Adjustment Method",
                    Authors: "<b style='color: red'>Jishu Wang</b>, Chao Zhu, Chen Miao, Rui Zhu<sup>*</sup>, Xuan Zhang<sup>*</sup>, Yahui Tang, Hexiang Huang, Chen Gao",
                    Journal: "IEEE Transactions on Intelligent Transportation Systems (TITS)",
                    Level: "SCI",
                    Area: "",
                    JCR: "JCR Q1",
                    CCF: "CCF-B",
                    IF: "IF: 9.551",
                    TOP: "",
                    Cite: 12,
                    State: "Article",
                    Link: "https://ieeexplore.ieee.org/document/9961087"
                }, {
                    Year: 2021,
                    Date: "2021.09.29",
                    Title: "ETC-Oriented Efficient and Secure Blockchain: Credit-Based Mechanism and Evidence Framework for Vehicle Management",
                    Authors: "<b style='color: red'>Jishu Wang</b>, Rui Zhu<sup>*</sup>, Tong Li, Fengsen Gao, Qiang Wang, Qiang Xiao",
                    Journal: "IEEE Transactions on Vehicular Technology (TVT)",
                    Level: "SCI",
                    Area: "",
                    JCR: "JCR Q1",
                    CCF: "",
                    IF: "IF: 5.978",
                    TOP: "",
                    Cite: 19,
                    State: "Article",
                    Link: "https://ieeexplore.ieee.org/document/9552488"
                }],
            Co: [
                // {
                //     Year: 2024,
                //     Date: "2024.01.22",
                //     Type: "Non-First",
                //     Title: "PEAE-GNN: Phishing Detection on Ethereum via Augmentation Ego-Graph based on Graph Neural Network",
                //     Authors: "Hexiang Huang, Xuan Zhang<sup>*</sup>, <b style='color: red'>Jishu Wang<sup>3rd</sup></b>, Chen Gao, Xue Li, Rui Zhu, Qiuying Ma",
                //     Journal: "IEEE Transactions on Computational Social Systems (TCSS)",
                //     Level: "SCI",
                //     Area: "",
                //     JCR: "JCR Q2",
                //     CCF: "CCF-C",
                //     IF: "IF: 5.3",
                //     TOP: "",
                //     State: "Article",
                //     Link: "https://ieeexplore.ieee.org/document/10410420/"
                // },
                // {
                //     Year: 2023,
                //     Date: "2023.09.02",
                //     Type: "Non-First",
                //     Title: "Fine-grained cybersecurity entity typing based on multimodal representation learning",
                //     Authors: "Baolei Wang, Xuan Zhang<sup>*</sup>, <b style='color: red'>Jishu Wang<sup>3rd</sup></b>, Chen Gao, Qing Duan, Linyu Li",
                //     Journal: "Multimedia Tools and Applications (MTA)",
                //     Level: "SCI",
                //     Area: "",
                //     JCR: "JCR Q2",
                //     CCF: "CCF-C",
                //     IF: "IF: 3.6",
                //     TOP: "",
                //     State: "Article",
                //     Link: "https://link.springer.com/article/10.1007/s11042-023-16839-z"
                // },
                {
                    Year: 2023,
                    Date: "2023.05.15",
                    Type: "Non-First",
                    Title: "ASTHGCN: Adaptive Spatio-Temporal Hypergraph Convolutional Network for Traffic Forecasting",
                    Authors: "Chao Zhu, Jing Chen, Rui Zhu<sup>*</sup>, Zhengqiong Wang, Shihan Liu, <b style='color: red'>Jishu Wang<sup>6th</sup></b>",
                    Journal: "IEEE International Conference on Software Analysis, Evolution and Reengineering (SANER) <sup>30th</sup>, Workshop",
                    Level: "EI",
                    Area: "",
                    JCR: "",
                    CCF: "CCF-B",
                    IF: "",
                    TOP: "",
                    State: "Article",
                    Link: "https://ieeexplore.ieee.org/document/10123444/"
                },
                {
                    Year: 2022,
                    Date: "2022.09.16",
                    Type: "Non-First",
                    Title: "A Knowledge Graph Completion Model Based on Contrastive Learning and Relation Enhancement Method",
                    Authors: "Linyu Li, Xuan Zhang<sup>*</sup>, Yubin Ma, Chen Gao, <b style='color: red'>Jishu Wang<sup>5th</sup></b>, Yong Yu, Zihao Yuan, Qiuying Ma",
                    Journal: "Knowledge-Based Systems (KBS)",
                    Level: "SCI",
                    Area: "",
                    JCR: "JCR Q1",
                    CCF: "CCF-C",
                    IF: "IF: 8.139",
                    TOP: "",
                    State: "Article",
                    Link: "https://www.sciencedirect.com/science/article/pii/S0950705122009820"
                },
                // {
                //     Year: 2021,
                //     Date: "2021.08.26",
                //     Type: "Non-First",
                //     Title: "A Discovery Method for Hierarchical Software Execution Behavior Models Based on Components",
                //     Authors: "Yahui Tang, Tong Li<sup>*</sup>, Rui Zhu<sup>*</sup>, Fei Du, <b style='color: red'>Jishu Wang<sup>5th</sup></b>, Zifei Ma",
                //     Journal: "Scientific Programming",
                //     Level: "SCI",
                //     Area: "",
                //     JCR: "JCR Q4",
                //     CCF: "",
                //     IF: "IF: 1.025",
                //     TOP: "",
                //     State: "Article",
                //     Link: "https://www.hindawi.com/journals/sp/2021/4788357/"
                // },
                {
                    Year: 2021,
                    Date: "2021.08.21",
                    Type: "Non-First",
                    Title: "Structure abstraction and behavior retention method for business process model based on complete finite prefix",
                    Authors: "Yue Huang, Rui Zhu<sup>*</sup>, Tong Li, <b style='color: red'>Jishu Wang<sup>4th</sup></b>, Yahui Tang, Changlong Lv",
                    Journal: "Computer Integrated Manufacturing Systems",
                    Level: "EI",
                    Area: "",
                    JCR: "",
                    CCF: "CCF-T3",
                    IF: "",
                    TOP: "",
                    State: "Article",
                    Link: "https://kns.cnki.net/kcms/detail/detail.aspx?dbcode=CAPJ&dbname=CAPJLAST&filename=JSJJ20210617001&uniplatform=NZKPT&v=EfDktvpY4SBHT571nclF6i5DxZhFMRWSkp6U5FuaPiHIJub4oLa2rwD%25mmd2F2hahj%25mmd2BP5"
                }]
        },
        Competitions: {
            Title: "Competitions",
            PersonalTitle: " Individual Competition",
            TeamTitle: "Team Competition",
            Personal: [{
                Name: " The 8th LanQiao Cup Competition,",
                Level: " Yunnan Province Third Prize (Java University Group B),",
                Date: " April 2017.",
            }, {
                Name: " The 11th LanQiao Cup Competition,",
                Level: " <b style='color: red'>Yunnan Province First Prize</b> (Python University Group),",
                Date: " October 2020.",
            }, {
                Name: " The 5th China College Students Software Testing Contest,",
                Level: " <b style='color: red'>Yunnan Province First Prize</b> (Mobile Development Test),",
                Date: " November 2020.",
            }, {
                Name: " The 11th LanQiao Cup Competition,",
                Level: " <b style='color: red'>National Third Prize</b> (Python University Group),",
                Date: " November 2020.",
            }, {
                Name: " The 12th LanQiao Cup Competition,",
                Level: " Yunnan Province Third Prize (Python University Group),",
                Date: " April 2021.",
            }, {
                Name: " The 13th LanQiao Cup Competition,",
                Level: " Yunnan Province Second Prize (Python Graduate Group),",
                Date: " April 2022.",
            },],
            Team: [{
                Name: " The 11th China University Student Service Outsourcing Innovation and Entrepreneurship Competition,",
                Level: "The third prize of the Central Regional Competition (<b style='color: red'>Leader</b>, Question A06, related to traffic flow prediction),",
                Date: " May 2020."
            }, {
                Name: " The 5th China University Computer Competition - Network Technology Challenge,",
                Level: " Second Prize in Southwest Division (Member, Question A, related to UAV, Image Recognition),",
                Date: " July 2020."
            }, {
                Name: " The 5th China University Computer Competition - Network Technology Challenge,",
                Level: " National Third Prize (Member, Question A, UAV, Image Recognition),",
                Date: " October 2020."
            }, {
                Name: " The 12th China University Student Service Outsourcing Innovation and Entrepreneurship Competition,",
                Level: "<b style='color: red'>The first prize of the Central Regional Competition (Leader</b>, Question A23, related to blockchain),",
                Date: " May 2021."
            }, {
                Name: " The 7th Chinese College Students \"Internet +\" Innovation and Entrepreneurship Competition,",
                Level: " Yunnan Province Bronze Award (Member, start-up group, related to software testing),",
                Date: " July 2021."
            }, {
                Name: " The 7th Chinese College Students \"Internet +\" Innovation and Entrepreneurship Competition,",
                Level: " Yunnan Province Bronze Award (Member, start-up group, related to blockchain),",
                Date: " July 2021."
            }, {
                Name: " The 6th China University Computer Competition - Network Technology Challenge,",
                Level: " Third Prize in Southwest Division (<b style='color: red'>Leader</b>, Question A, related to blockchain),",
                Date: " July 2021."
            }, {
                Name: " The 12th China University Student Service Outsourcing Innovation and Entrepreneurship Competition,",
                Level: "<b style='color: red'> National Second Prize (Leader</b>, Question A23, related to blockchain),",
                Date: " August 2021."
            }, {
                Name: " The 7th China University Computer Competition - Network Technology Challenge,",
                Level: " Second Prize in Southwest Division (<b style='color: red'>Leader</b>, Question A, related to blockchain),",
                Date: " July 2022."
            }, {
                Name: " The 8th Chinese College Students \"Internet +\" Innovation and Entrepreneurship Competition,",
                Level: " Yunnan Province Bronze Award (<b style='color: red'>Leader</b>, start-up group, related to blockchain),",
                Date: " July 2022."
            }, {
                Name: " The 7th China University Computer Competition - Network Technology Challenge,",
                Level: "<b style='color: red'> National Third Prize (Leader</b>, Question A, related to blockchain),",
                Date: " September 2022."
            }, {
                Name: " The 14th China University Student Service Outsourcing Innovation and Entrepreneurship Competition,",
                Level: "The third prize of the Central Regional Competition (<b style='color: red'>Leader</b>, Question A24, related to blockchain),",
                Date: " May 2023."
            }, {
                Name: " The 8th China University Computer Competition - Network Technology Challenge,",
                Level: " Second Prize in Southwest Division (<b style='color: red'>Leader</b>, Question A, related to blockchain),",
                Date: " June 2023."
            }, {
                Name: " The 8th China University Computer Competition - Network Technology Challenge,",
                Level: "<b style='color: red'> National Third Prize (Leader</b>, Question A, related to blockchain),",
                Date: " September 2023."
            },{
                Name: " The 15th China University Student Service Outsourcing Innovation and Entrepreneurship Competition,",
                Level: "The third prize of the Central Regional Competition (<b style='color: red'>Leader</b>, Question A22, related to blockchain),",
                Date: " May 2024."
            },{
                Name: " The 9th China University Computer Competition - Network Technology Challenge,",
                Level: " Second Prize in Southwest Division (<b style='color: red'>Leader</b>, Question A, related to blockchain),",
                Date: " June 2024."
            },{
                Name: " The 9th China University Computer Competition - Mobile Application Innovation,",
                Level: " Second Prize in Southwest Division (Member, Innovation, related to blockchain and computer vision),",
                Date: " June 2024."
            },{
                Name: " The 18th iCAN Innovation Contest,",
                Level: " Second Prize in Southwest Division (Member, related to blockchain and computer vision),",
                Date: " June 2024."
            },]
        },
        Funds: {
            Title: "Funds",
            Leader: {
                Title: "Leader",
                Content: [{
                    Name: " Research on Reputation Mechanism of Efficient Network Charge Inspection Based on Evidence Chain,",
                    Type: " Postgraduate Program of Scientific Research Fund of Yunnan Provincial Department of Education,",
                    Funding: " 2021Y018 (0.5 million ¥),",
                    Date: " February 2021 - February 2022.",
                }, {
                    Name: " Data governance in the complex environment of the coordinated power monitoring system of the blockchain and the cloud,",
                    Type: " The 14th Graduate Research Innovation Project of Yunnan University,",
                    Funding: " KC-2222958 (1 million ¥),",
                    Date: " November 2022 - May 2024.",
                }]
            },
            Member: {
                Title: "Member",
                Content: [{
                    Name: " Multi-level software operation process mining method based on component division,",
                    Type: " The 12th Graduate Research Innovation Project of Yunnan University (Key Project),",
                    Funding: " 2020Z71 (1 million ¥),",
                    Date: " October 2020 - October 2021.",
                }, {
                    Name: " Research on the deep dynamic reputation mechanism and edge trusted trading system of car networking,",
                    Type: " The 2th professional degree graduate practice innovation project at Yunnan University,",
                    Funding: " ZC-22221624（0.5 million ¥）,",
                    Date: " February 2023 - February 2024.",
                }]
            }
        },
        Patents: {
            Title: "Patents",
            First: {
                Title: "First Author",
                Content: [{
                    Name: " An Evidence Chain Framework-based Reputation ETC System and Data Protection Method and Reputation Value-based Vehicle Behavior Management Method,",
                    ID: " CN202110277565.4",
                    State: " (Authorized)."
                }]
            },
            Co: {
                Title: "Co-Author",
                Content: [{
                    Name: " A shared parking management method and system based on proof chain of points,",
                    ID: " CN202110564049.X",
                    State: " (Authorized)."
                }, {
                    Name: " An approach to NL2SQL with joint semantic parsing and semantic component matching,",
                    ID: "CN202211131620.X",
                    State: " (Authorized)."
                }, {
                    Name: " A blockchain-based method and system for determining highway costs,",
                    ID: "CN202111187042.3",
                    State: " (Substantive review in progress)."
                }, {
                    Name: " A clinical pathway optimization method based on process mining,",
                    ID: " CN202011525241.X",
                    State: " (Substantive review in progress)."
                }, {
                    Name: " A method for filling missing values of traffic flow based on non-negative matrix decomposition and dynamic time regularization algorithm,",
                    ID: " CN202011617854.6",
                    State: " (Authorized)."
                }, {
                    Name: " A two-dimensional genetic process mining method based on an executor process tree,",
                    ID: " CN202011503109.9",
                    State: " (Substantive review in progress)."
                }]
            }
        },
        CopyRights: {
            Title: "Software Copyrights",
            First: {
                Title: "First Author",
                Content: [{
                    Name: " Personal Blog System V1.0,",
                    ID: " 2020R11L387460.",
                }, {
                    Name: " Campus official website system V1.0,",
                    ID: " 2020R11L2617978.",
                }, {
                    Name: " Jianshui Terroir and Culture Display System V1.0,",
                    ID: " 2020R11L2594452.",
                }]
            },
            Co: {
                Title: "Co-Author",
                Content: []
            }
        },
        Certificates: {
            Title: "Certificates",
            Content: [
                {
                    Name: " China Qualification Certificate of Computer and Software Technology Proficiency—Software Designer,",
                    Date: " 2018."
                },
                {
                    Name: " CET-4,",
                    Date: " 2018."
                },
                {
                    Name: " China Qualification Certificate of Computer and Software Technology Proficiency—Software Assessor,",
                    Date: " 2019."
                }
            ]
        },
        Rewards: {
            Title: "Awards (Honors)",
            Content: [
                {
                    Name: " Kunming University Scholarship for Outstanding Student Leaders at School Level,",
                    Date: " October 2016."
                },
                {
                    Name: " Outstanding Lecturer of Computer Classroom in \"Technological Wind Action\" of Kunming University,",
                    Date: " December 2016."
                },
                {
                    Name: " Kunming University Expo Car Market Scholarship,",
                    Date: " April 2017."
                },
                {
                    Name: " Outstanding Lecturer of Computer Classroom in \"Technological Wind Action\" of Kunming University,",
                    Date: " May 2017"
                },
                {
                    Name: " Second-class scholarship for the third best student of Kunming University,",
                    Date: " October 2017."
                },
                {
                    Name: " <b style='color: red'>Yunnan Provincial Government Scholarship</b>,",
                    Date: " October 2018."
                },
                {
                    Name: " Outstanding Graduation Thesis of Kunming University,",
                    Date: " May 2019."
                },
                {
                    Name: " Outstanding graduates from Kunming University (undergraduate),",
                    Date: " July 2019."
                },
                {
                    Name: " <b style='color: red'>Excellent graduates in Yunnan Province (undergraduate)</b>,",
                    Date: " July 2019."
                },
                {
                    Name: " Yunnan University First Class Academic Scholarship for Graduate Students,",
                    Date: " October 2020."
                },
                {
                    Name: " Yunnan University Second Class Academic Scholarship for Graduate Students,",
                    Date: " October 2021."
                },
                {
                    Name: " <b style='color: red'>National Scholarship for Graduate Students</b>,",
                    Date: " October 2021."
                },
                {
                    Name: " Excellent Graduates from Yunnan University (Master's Degree),",
                    Date: " March 2022."
                },
                {
                    Name: " <b style='color: red'>Excellent Graduates in Yunnan Province (Master's Degree)</b>,",
                    Date: " March 2022."
                },
                {
                    Name: " Yunnan University Second Class Academic Scholarship for Graduate Students,",
                    Date: " October 2022."
                },
                {
                    Name: " Yunnan University First Class Academic Scholarship for Graduate Students,",
                    Date: " October 2023."
                },
                {
                    Name: " Yunnan University First Class Academic Scholarship for Graduate Students,",
                    Date: " October 2024."
                }
            ]
        }
    },
    Link: {
        Title: "Friend Link",
        Content: "<p>Please leave a message in the following format to add a friend link.</p><p>Name: FFC's small site</p><p>Address: http://www.loveffc.cn</p><p>Avatar (optional, not fill in the default avatar): <a href='http://www.loveffc.cn:8080/img/HeadImage2.99b5bf64.jpg' style='float: none;color: limegreen'>http://www.loveffc.cn:8080/img/HeadImage2.99b5bf64.jpg</a></p>",
        Link: "http://www.loveffc.cn:8080/img/HeadImage2.99b5bf64.jpg"
    }
}